module.exports = require('./helpers/bundle-url').getBundleURL('1adP4') + "logo.c51670a8.svg";